/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Kitchen
 * 
 * 1 = Bathroom
 * 
 * 2 = WC
 * 
 * 3 = Lounge
 * 
 * 4 = Hallway
 * 
 * 5 = Landing
 * 
 * 6 = Stairs
 * 
 * 7 = Bed1
 * 
 * 8 = Bed2
 * 
 * 9 = Bed3
 */
export enum AreaOfWorks {
  Kitchen = 0,
  Bathroom = 1,
  WC = 2,
  Lounge = 3,
  Hallway = 4,
  Landing = 5,
  Stairs = 6,
  Bed1 = 7,
  Bed2 = 8,
  Bed3 = 9
}
